import * as React from 'react'
import {
  InfoBlockCheckListBottomSolid,
  InfoBlockCheckListContainer, InfoBlockCheckListDiv,
  InfoBlockCheckListIconCol, InfoBlockCheckListText,
  InfoBlockCheckListTextCol, InfoBlockCheckListTitle
} from './InfoBlockCheckList.elements'

type Props = {
  title: string;
  text: string;
  index: number;
  textColor?: string;
}

const imageUrlFromIndex = (index: number) => {
  if(index === 1){
    return 'https://media.healthiq.com/icn/icn32-retail-rate-check.png';
  }
  return 'https://media.healthiq.com/icn/icn32-special-rate-check.png';
}

export const InfoBlockCheckList: React.FunctionComponent<Props> = ({title, text, index, textColor}) => (
  <InfoBlockCheckListContainer isLast={index === 1}>
    <InfoBlockCheckListDiv>
      <InfoBlockCheckListIconCol imageUrl={imageUrlFromIndex(index)} />
      <InfoBlockCheckListTextCol>
        <InfoBlockCheckListTitle textColor={textColor} dangerouslySetInnerHTML={{ __html: title }} />
        <InfoBlockCheckListText textColor={textColor} dangerouslySetInnerHTML={{ __html: text }} />
      </InfoBlockCheckListTextCol>
    </InfoBlockCheckListDiv>
    <InfoBlockCheckListBottomSolid textColor={textColor} index={index}/>
  </InfoBlockCheckListContainer>
)
